import { GameFontStyle, GameLang, GameStyle } from "@lib/js-slingo-pawnshop-core/dist";
import { FeatureGreenFishProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/features/greenfish/FeatureGreenFishProperties";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
export class FeatureGreenFishLandscapeProperties extends FeatureGreenFishProperties {
    setDefaultValues() {
        this.background = new SpriteProperties("CupsBackground", "Game", new Point(973, 512), new Point(1, 1), new Point(0.5, 0.5));
        this.cat = new SpineProperties("CupsCat", "Game", new Point(973, 705), new Point(1, 1));
        const cupScale = 1;
        const xOffset = 300 * cupScale * 1.1;
        const yOffset = 130 * cupScale * 0.95;
        const xBase = 0 * cupScale;
        const yBase = 30 * cupScale;
        const cupScalePoint = new Point(cupScale, cupScale);
        this.cups = [
            new SpineProperties("Cup", "Game", new Point(xBase - (xOffset * 2), yBase + yOffset * 0), cupScalePoint),
            new SpineProperties("Cup", "Game", new Point(xBase - (xOffset * 1), yBase + yOffset * 0), cupScalePoint),
            new SpineProperties("Cup", "Game", new Point(xBase, yBase + yOffset * 0), cupScalePoint),
            new SpineProperties("Cup", "Game", new Point(xBase + (xOffset * 1), yBase + yOffset * 0), cupScalePoint),
            new SpineProperties("Cup", "Game", new Point(xBase + (xOffset * 2), yBase + yOffset * 0), cupScalePoint),
            new SpineProperties("Cup", "Game", new Point(xBase - (xOffset * 1.5), yBase + yOffset * 1), cupScalePoint),
            new SpineProperties("Cup", "Game", new Point(xBase - (xOffset * 0.5), yBase + yOffset * 1), cupScalePoint),
            new SpineProperties("Cup", "Game", new Point(xBase + (xOffset * 0.5), yBase + yOffset * 1), cupScalePoint),
            new SpineProperties("Cup", "Game", new Point(xBase + (xOffset * 1.5), yBase + yOffset * 1), cupScalePoint),
        ];
        this.catnip = new SpriteProperties("prop_snuffbox", "Game", new Point(0, 0), new Point(0.6, 0.6), new Point(0.5, 0.5)),
            this.catnipRays = new SpineProperties("GodRays", "Game", new Point(0, 0), new Point(0.6, 0.6), new Point(0.5, 0.5));
        this.cupFloorPosition = new Point(0, 498);
        this.collectAllAcumulationCatSpacePosition = new Point(0, -220);
        this.pickedCashPrizeDisplayCatSpacePosition = new Point(0, -300);
        this.logoProperties = new SpriteProperties(GameStyle.LOGO, GameStyle.MODULE, new Point(1509, 133), new Point(0.24, 0.24), new Point(0, 0));
        this.titleText = new TextFieldProperties(GameFontStyle.FEATURE_TITLE, new Point(973, 20), GameLang.BONUS_LABEL3, ControlConstants.CENTER, ControlConstants.CENTER, new Point(800, 200));
        this.helpText = new TextFieldProperties(GameFontStyle.FEATURE_HELP_TEXT, new Point(973, 155), GameLang.BONUS_PROMPT1, ControlConstants.CENTER, ControlConstants.CENTER, new Point(800, 200));
        const fishScale = new Point(0.13, 0.13);
        this.fish = {
            red: new SpineProperties("FishRed", "Game", null, fishScale),
            green: new SpineProperties("FishGreen", "Game", null, fishScale),
            blue: new SpineProperties("FishBlue", "Game", null, fishScale),
            purple: new SpineProperties("FishPurple", "Game", null, fishScale),
            gold: new SpineProperties("FishGold", "Game", null, fishScale),
        };
        this.watchOffscreenPositions = {
            red: new Point(-620, -755),
            purple: new Point(620, -755),
            gold: new Point(-620, -485),
            blue: new Point(620, -485),
        };
        this.watchPositions = {
            red: new Point(-330, -755),
            purple: new Point(330, -755),
            gold: new Point(-375, -485),
            blue: new Point(375, -485),
        };
        this.bowl = new SpineProperties("Bowl", "Game", new Point(973, 440), new Point(0.75, 0.75));
        this.pickedPrize = new TextFieldProperties(GameFontStyle.FEATURE_GREEN_FISH_PICKED_PRIZE, null, null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(200, 200));
        this.missedPrize = new TextFieldProperties(GameFontStyle.FEATURE_GREEN_FISH_PICKED_PRIZE, null, null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(200, 200));
        this.collectAllAnimation = new SpineProperties("Whirlpool", Modules.GAME);
        this.pickedPrize.fontProperties.letterSpacing = -2;
        this.pickedPrize.fontProperties.trim = this.missedPrize.fontProperties.trim = true;
        this.pickedPrize.fontProperties.font.setPaddingPercentage(0.1);
        this.bubble = new SpineProperties("BubblePick", "Game");
        this.bubbleLocations = [
            new Point(-169, 200),
            new Point(-262, -117),
            new Point(-89, -211),
            new Point(132, -187),
            new Point(324, -80),
            new Point(-339, 59),
            new Point(-115, 8),
            new Point(47, 219),
            new Point(75, -1.5),
            new Point(-172, 205),
        ];
        this.idleFishRangeX = [-620, +620];
        this.idleFishRangeY = [-770, -545];
    }
}
